unit uTransform;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, Vcl.StdCtrls,
  WEBLib.StdCtrls, Vcl.Controls, WEBLib.ExtCtrls, Vcl.Imaging.pngimage, WEBLib.Controls, WEBLib.Dialogs,
  WEBLib.SyntaxMemo, WEBLib.WebCtrls, Web, JS, libfilereader, WEBLib.Buttons,
  WEBLib.REST, WEBLib.Grids, WEBLib.DBCtrls, Data.DB, WEBLib.DB, WEBLib.CDS;

type
  TTransform = class(TForm)
    Produtos_Con: TClientConnection;
    divTabela: THTMLDiv;
    btnPesquisar: TButton;
    btnImprimir: TButton;
    Msg01: TMessageDlg;
    toggleView: TCheckBox;
    Produtos_DSET: TClientDataSet;
    Cargas_idudv: TIntegerField;
    Cargas_DataMvto: TDateTimeField;
    Cargas_QtdeUD: TIntegerField;
    btnETQ: TButton;
    execAPIs: THttpRequest;
    btnLoadFILE: TFilePicker;
    WebMessageDlg1: TMessageDlg;
    nArq: TMemo;
    nRESP: TMemo;
    myBtn: TButton;
    WebBitBtn1: TBitBtn;
    procedure Produtos_ConAfterConnect(Sender: TObject);
    procedure btnPesquisarClick(Sender: TObject);
    procedure btnImprimirClick(Sender: TObject);
    procedure btnETQClick(Sender: TObject);
    procedure btnLoadFILEChange(Sender: TObject);
    procedure btnLoadFILEGetFileAsText(Sender: TObject; AFileIndex: Integer;
      AText: string);
    procedure WebFormShow(Sender: TObject);
    procedure nArqDblClick(Sender: TObject);
    [async] procedure myBtnClick(Sender: TObject); async;
    procedure WebBitBtn1Click(Sender: TObject);
  private
    { Private declarations }
public
    { Public declarations }
    cItens, JSok: integer;
    vItens: string;
    qCards: integer;

    fl: Boolean;
    fr: TFileReader;
    FFileName: string;

    procedure LoadDatas;
    procedure LoadTable;
    procedure LoadFile;
  protected procedure LoadDFMValues; override; end;

var
  Transform: TTransform;

implementation

{$R *.dfm}

uses
  uFrmMain, uGrafico;

procedure TTransform.LoadDatas;
var
  xURL, Criterio: string;
begin
//B- Pesquisa as Datas
      cItens:= 0;     //Contador dos itens
      qCards:= 4;     //Etiquetas por Linha

      xURL:= '';
      Criterio:= '';

      try
        Produtos_Con.Active:= false;

        //BaseURL := 'produtos?offset='+IntToStr(xOffset)+'&fetch='+IntToStr(xLinhasPagina);
        xURL := FrmMain.BaseURL + 'carga?offset=0&fetch=6&iduser=47&qtdesaldo%3E0';
        //http://localhost:8083/api/carga?offset=0&fetch=10&iduser=47&qtdesaldo%3E0

        //MousePointer.Cursor := -11;
        if Criterio = '' then
        begin
          //UTF8Encode(BaseURL);
          Produtos_Con.URI := xURL;
        end else begin

          //Produtos_Con.URI := BaseURL+'&'+xCampo+'='+Interm;
          Produtos_Con.URI := xURL;
          // ' = %27
          // % = %25;
          // % = &#37;
          //produtos?offset=0&fetch=100&gestao=0
        end;
        Produtos_Con.Active:= true;
      finally
        //Screen.Cursor := 0;
      end;
//B- Pesquisa as Datas
end;

procedure TTransform.LoadFile;
var
  ext: string;
begin
  if Assigned(btnLoadFILE.Files[0]) then
  begin
    fl := True;
    btnLoadFILE.Files[0].GetFileAsText;
    FFileName := btnLoadFILE.Files[0].Name;
    ext := ExtractFileExt(FFileName);
    //SetSyntaxMemoMode(ext);
  end;
end;

procedure TTransform.LoadTable;
var
  i: integer;
  xHeader, xItens: string;
begin

    xHeader:=   //Header de Table  '<table>'+

          '<thead>'+
              '<tr>'+
                  '<th>#</th>'+
                  '<th>Data da Leitura</th>'+
                  '<th>Nº Etiquetas</th>'+
                  //'<th>Situação</th>'+
                  '<th>Ações</th>'+
              '</tr>'+
          '</thead>'+
        '<tbody>';

    cItens:= 0;
    xItens:= '';
    vItens:= '';
    repeat
        //Cards
        xItens:= xItens +
        '<tr>'+
          '<td data-name="Nº Leitura" id="leitura' + IntToStr(cItens) + '" value="' + Produtos_DSET.FieldByName('idudv').AsString + '">' + Produtos_DSET.FieldByName('idudv').AsString + '</td>'+
          '<td data-name="Data Leitura">' + FormatDateTime('dd/mm/yyyy hh:mm', Produtos_DSET.FieldByName('DataMvto').AsDateTime) + '</td>'+
          '<td data-name="Nº Etiquetas">' + Produtos_DSET.FieldByName('qtdeud').AsString + '</td>'+
          //'<td class="status"><span class="decline">Declinado</span></td>'+


					'<td><button type="button" class="btn btn-warning btn-sm" id="edit' + IntToStr(cItens) + '" ><i class="fa fa-edit"></i></button>'+
          //'<td><button type="button" class="btn btn-warning btn-sm" id="edit" onclick="myBtnClick()" onclick="javascript:alert(' + #39 + 'Número do Identificador: ' + Produtos_DSET.FieldByName('idudv').AsString + #39 + ')"><i class="fa fa-edit"></i></button>'+

					//'<button type="button" class="btn btn-danger btn-xs" id="delete"><i class="fa fa-trash" onclick="Act_delete(xxx)"></i></button></td>'+
        '</tr>';

        //Vefifica se é 0 começo da linha (8 mod 4 = 0), verificar antes de somar
        if cItens MOD qCards = 0 then
        begin
           vItens:= vItens + '<div class="row">';
        end;

        vItens:= vItens +
        '<div class="col-sm">'+
        '<section class="card contact">'+
        '<img id="barcode' + IntToStr(i) + '"/>'+
        '<script>JsBarcode("#barcode' + IntToStr(i) + '", "' + Produtos_DSET.FieldByName('idudv').AsString + '", {height: 50});</script>'+
        '<span>' + FormatDateTime('dd/mm/yyyy hh:mm', Produtos_DSET.FieldByName('DataMvto').AsDateTime) + '</span>'+
        '<span>' + Produtos_DSET.FieldByName('qtdeud').AsString + '</span>'+
        '</section>'+
        '</div>';

        inc(cItens); //Incrementa Itens para poder variar o código de barras

        //Vefifica se é 0 começo da linha (8 mod 4 = 0), verificar no último campo
        // Não precisa da instrução { and (cItens <> 0 )} pois somou acima
        if cItens MOD qCards = 0 then
        begin
           vItens:= vItens + '</div>';
        end;

        Produtos_DSET.Next;

    until(Produtos_DSET.Eof);

    //Transfere Dados para Div
    divTabela.HTML.Add(xHeader + xItens + '</tbody>');

end;

procedure TTransform.myBtnClick(Sender: TObject);
var
  PView: TGrafico;
begin
  PView:= TGrafico.Create(Self);
  try
    PView.Popup:= True;
    PView.Border:= fbDialogSizeable;

    //Carrega HTML e CONTROLES
    Await(TGrafico, PView.Load());

    Await(TModalResult, PView.Execute);
  finally
    PView.Free;
  end;

end;

procedure TTransform.nArqDblClick(Sender: TObject);
begin
      nRESP.Visible:= not nRESP.Visible;
end;

procedure TTransform.Produtos_ConAfterConnect(Sender: TObject);
begin
    LoadTable;
    WebBitBtn1Click(Self);
end;

procedure TTransform.btnLoadFILEChange(Sender: TObject);
begin
    //nCont.Caption := '';
    nRESP.Text    := '';
    nARQ.Text   := '';
    //nRESP.Text    := '';

    LoadFile;
end;

procedure TTransform.btnLoadFILEGetFileAsText(Sender: TObject;
  AFileIndex: Integer; AText: string);
begin
    //WebSyntaxMemo1.Text := AText;
    nARQ.Text := AText;
end;

procedure TTransform.WebBitBtn1Click(Sender: TObject);
begin

      // When the user clicks on the password field, show the message box
      // document.getElementById("message").style.display = "block";
      //  var myOBJ  = document.getElementById("Table");
      //  myOBJ.classList.remove("tbody");

//        var myPass  = document.getElementById("edit1");
//
//
//        myPass.OnClick = function() {
//
//            alert("Número do Identificador: 111");
//      alert ("Hello World!");
//        }

    //Rotina ASM em Javascript    bolhaTable   Table    tbody
    //Adiciona eventos nos botões da Grade
    if JSok = 0 then
    begin
      JSok:= 1;
      //Rotina ASM em Javascript    bolhaTable   Table    tbody
      //Adiciona eventos nos botões da Grade
      //document.getElementById("cores").addEventListener("click", mudarCor);
      asm
          function mudarCor(novaCor) {
            var elemento = document.getElementById("para1");
            elemento.style.color = novaCor;
          }

          function myFunction() {
              var url = document.getElementById('leitura1').value;
              alert('O valor é '+url);
          }


          document.getElementById("edit0").addEventListener("cores", mudarCor);

          document.getElementById("edit0").addEventListener("click", myFunction);
          document.getElementById("edit1").addEventListener("click", myFunction);
          document.getElementById("edit2").addEventListener("click", myFunction);
          document.getElementById("edit3").addEventListener("click", myFunction);

      end;
    end;

end;

procedure TTransform.WebFormShow(Sender: TObject);
begin
    JSok:= 0;
    LoadDatas;
end;

procedure TTransform.btnETQClick(Sender: TObject);
var
  OKArqProd: boolean;
  zLinhas, zCont, zContPROD, zCampos, xFDstart, xFDend: integer;
  xProd, xProdOLD, xDesenho, xDESCR, xURL: string;
begin
    if Produtos_DSET.IsEmpty then
    begin
        ShowMessage('Crie ao menos uma data !');
        exit;
    end;

    if nARQ.Lines.Count = 0 then
    begin
      ShowMessage('Não existe dados para o processamento !');
      exit;
    end;

    //A- Verifica se o arquivo é de Produtos e tem os dados corretamente-90
    OKArqProd   := true;
    for zLinhas := 0 to nARQ.Lines.Count-1 do
    begin

        //Se envontrar '^MCY' então não é etiqueta de Produtos
        if pos('^MCY', nARQ.Lines[zLinhas]) > 0 then
        begin
            OKArqProd   := false;
        end;

    end;

    xProdOLD:= '';

    zLinhas   := 0;
    zContPROD := 0;
    for zLinhas := 0 to nARQ.Lines.Count-1 do
    begin

        //Se envontrar '^MCY' então não é etiqueta de Produtos
        //Blocos de Produtos
        if pos('^MCY', nARQ.Lines[zLinhas]) > 0 then
        begin
            //nRESP.Lines.Add('Este é um arquivo de volume e não de Produtos !');
            MessageDlg('Este é um arquivo de volume e não de Produtos !', mtError, [mbOK]);
            //MessageDlg('Usuário e senha são exigidos !', mtError, []);
            exit;
        end;

        //Blocos de Produtos
        if pos('CI28', nARQ.Lines[zLinhas]) > 0 then
        begin
            inc(zCont);   //Contador de Produto
            //nCont.Caption:= htmARQ.Lines[zLinhas];
            zCampos:= 0;

            xDesenho  := '';
            xProd     := '';
            xDesenho  := '';
            xDESCR    := '';
        end;

        //Campos de Produtos
        xFDstart:= pos('^FD', nARQ.Lines[zLinhas]);
        if xFDstart > 0 then
        begin
            inc(zCampos);   //Inclusão de campos

            //nCont.Caption:= htmARQ.Lines[zLinhas];
            xFDend:= 0;
            xFDend:= pos('^FS', nARQ.Lines[zLinhas]);
            if xFDend > 0 then
            begin
            //Está na mesma linha

              if xFDend >= xFDstart then
              begin

                  if xFDend > 0 then
                  begin
                      case zCampos of
                        1: begin
                        //Produto
                            inc(zContPROD);
                            xProd:= Copy(nARQ.Lines[zLinhas], xFDstart + 3, xFDend - xFDstart - 3);
                        end;
                        4: begin
                        //Descrição
                            xDESCR:= Copy(nARQ.Lines[zLinhas], xFDstart + 3, xFDend - xFDstart - 3);
                        end;
                        7: begin
                        //Desenho
                            xDesenho:= Copy(nARQ.Lines[zLinhas], xFDstart + 3, xFDend - xFDstart - 3);
                        end;
                      end;
                  end else begin
                  //Desenho (Não tem ^Fs no final)
                      if zCampos = 7 then
                      begin
                          xDesenho:= Copy(nARQ.Lines[zLinhas], xFDstart + 3, 100);
                      end;
                  end;
              end;

            end else begin
            //Não está na mesma linha
                //Desenho (Não tem ^Fs no final)
                xDesenho:= Copy(nARQ.Lines[zLinhas], xFDstart + 3, 100);
            end;

            if zCampos = 7 then
            begin

                if xProdOLD <> xProd then
                begin
                    xProdOLD  := xProd;
                    zContPROD := 1;
                end;

                sleep(200); //Tempo de 200 milisegundos

                //01- Mostra dados a serem imputados
                nRESP.Lines.Add('{'
                + '"idmain": ' + IntToStr(zContPROD) + ', '
                + '"produto": "' + xProd + '", '
                + '"desenho": "' + xDesenho + '", '
                + '"descr": "' + xDESCR + '", '
                + '"und": "Und", '
                + '"iduser": 47 '
                + '}');


                //02- Cadastra os Produtos
                //try
                      execAPIs.URL := FrmMain.BaseURL + 'produtos/novo_produto';
                      execAPIs.Command := httpPOST;
                      execAPIs.Headers.Clear;
                      execAPIs.Headers.AddPair('Content-Type','application/json');
                      execAPIs.Headers.AddPair('Accept','application/json, text/plain, */*');
                      execAPIs.PostData := '{'
                      + '"produto": "' + xProd + '", '
                      + '"desenho": "' + xDesenho + '", '
                      + '"descr": "' + xDESCR + '", '
                      + '"und": "Und", '
                      + '"iduser": 47 '
                      + '}';
                      execAPIs.Execute();
                {finally
                  except on E: Exception do
                    begin
                      RS.Visible:= true;
                      RS.Text:= 'Feedback Error: ['+E.ClassName+'] '+E.Message;
                    end;
                  end;}
                //end;
                //03- Cadastra a etiqueta na data selecionada

            end;

        end;

    end;

    ShowMessage('Processamento concluído com sucesso !');

//    //Cadastra a UD
//    //upProdutos.URL := 'produtos/zidmain?idmain=0';
//    execAPIs.URL := FrmMain.BaseURL + 'itensnfuds/nova_ud';
//    execAPIs.Command := httpPOST;
//    execAPIs.Headers.Clear;
//    execAPIs.Headers.AddPair('Content-Type','application/json');
//    execAPIs.Headers.AddPair('Accept','application/json, text/plain, */*');
//    execAPIs.PostData := '{"idprod": "34073", '+    //Identificador do Produto
//    '"qtdeud": "100", '+       //Quantidade do Produto
//    '"iduser": "47"}';         //Identificador do Usuário
//    execAPIs.Execute();


end;

procedure TTransform.btnPesquisarClick(Sender: TObject);
    procedure Afterdialog(Value: TModalResult);
    var
    xURL, Criterio: string;
    begin


          if Value = mrYes then
          begin

//A- Cadastra o volume para determinar as datas
            //B- Cadastra o volume para determinar as datas
            execAPIs.URL := FrmMain.BaseURL + 'carga/nova_carga';
            execAPIs.Command := httpPOST;
            execAPIs.Headers.Clear;
            execAPIs.Headers.AddPair('Content-Type','application/json');
            execAPIs.Headers.AddPair('Accept','application/json, text/plain, */*');
            execAPIs.PostData := '{'
            + '"iduser": 47, '
            + '"idpess": "606"'
            + '}';
            execAPIs.Execute();
//A- Cadastra o volume para determinar as datas

//B- CPesquisa as Datas
            cItens:= 0;     //Contador dos itens
            qCards:= 4;     //Etiquetas por Linha

            xURL:= '';
            Criterio:= '';

            try
              Produtos_Con.Active:= false;

              //BaseURL := 'produtos?offset='+IntToStr(xOffset)+'&fetch='+IntToStr(xLinhasPagina);
              xURL := FrmMain.BaseURL + 'carga?offset=0&fetch=6&iduser=47&qtdesaldo%3E0';
              //http://localhost:8083/api/carga?offset=0&fetch=10&iduser=47&qtdesaldo%3E0

              //MousePointer.Cursor := -11;
              if Criterio = '' then
              begin
                //UTF8Encode(BaseURL);
                Produtos_Con.URI := xURL;
              end else begin

                //Produtos_Con.URI := BaseURL+'&'+xCampo+'='+Interm;
                Produtos_Con.URI := xURL;
                // ' = %27
                // % = %25;
                // % = &#37;
                //produtos?offset=0&fetch=100&gestao=0
              end;
              Produtos_Con.Active:= true;
            finally
              //Screen.Cursor := 0;
            end;
//B- CPesquisa as Datas


          end;



    end;


begin
  Msg01.ShowDialog('Deseja criar uma nova data de leitura ?', mtConfirmation, [mbYes, mbNo], @AfterDialog);


end;

procedure TTransform.btnImprimirClick(Sender: TObject);

    procedure Afterdialog(Value: TModalResult);
    var
    xInicio, xCards, xFim: string;
    begin

          if Value = mrYes then
          begin

              //Cabeçalho do HTML
              xInicio:= '<html lang="en">'+
              '<head>'+
                '<meta charset="UTF-8">'+
                '<meta name="viewport" content="width=device-width, initial-scale=1.0">'+
                '<meta http-equiv="X-UA-Compatible" content="IE=edge">'+
                '<title>Responsive Cards page A4 Report</title>'+
                '<link href="https://fonts.googleapis.com/css?family=Varela+Round" rel="stylesheet" />'+
                '<link rel="stylesheet" href="style.css">'+
                '<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">'+
                '<link href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet" '+
                'integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN" crossorigin="anonymous">'+

                //Barcode
                '<script src="assets/dist/JsBarcode.all.js"></script>'+
                '<script>'+
                  'Number.prototype.zeroPadding = function(){'+
                    'var ret = "" + this.valueOf();'+
                    'return ret.length == 1 ? "0" + ret : ret;'+
                  '};'+
                '</script>'+
              '</head>'+
              '<body onload="window.print()">'+
              //'<div class="col-12 text-center my-4">';
              '<div class="container">';

              xCards:= vItens;

              //Final do HTML
              xFim:= '</div></body></html>';

              //Html completo para testes (Deixar ativo e copiar após a impressão para testes)
              //htmTeste.Text:= xInicio + vItens + xFim;

              //Complementar as últimas etiquetas devido o posicionamento das mesmas

              //Javascript
              asm

               //var divToPrint = document.getElementsByClassName('header_table')[0];
               var anotherWindow = window.open('', 'Print-Window');
               anotherWindow.document.open();
               anotherWindow.document.write(
               xInicio +


               xCards +


               xFim);
               anotherWindow.document.close();

              end;
          end;

    end;


begin
  Msg01.ShowDialog('Deseja imprimir as etiquetas ?', mtConfirmation, [mbYes, mbNo], @AfterDialog);

end;

procedure TTransform.LoadDFMValues;
begin
  inherited LoadDFMValues;

  divTabela := THTMLDiv.Create('Table');
  btnPesquisar := TButton.Create('pesquisar');
  btnImprimir := TButton.Create('imprimir');
  Msg01 := TMessageDlg.Create(Self);
  toggleView := TCheckBox.Create('toggleView');
  btnETQ := TButton.Create('idprocessar');
  btnLoadFILE := TFilePicker.Create('xArq');
  WebMessageDlg1 := TMessageDlg.Create(Self);
  nArq := TMemo.Create('nArq');
  nRESP := TMemo.Create(Self);
  myBtn := TButton.Create('datas');
  WebBitBtn1 := TBitBtn.Create(Self);
  Produtos_Con := TClientConnection.Create(Self);
  Produtos_DSET := TClientDataSet.Create(Self);
  Cargas_idudv := TIntegerField.Create(Self);
  Cargas_DataMvto := TDateTimeField.Create(Self);
  Cargas_QtdeUD := TIntegerField.Create(Self);
  execAPIs := THttpRequest.Create(Self);

  divTabela.BeforeLoadDFMValues;
  btnPesquisar.BeforeLoadDFMValues;
  btnImprimir.BeforeLoadDFMValues;
  Msg01.BeforeLoadDFMValues;
  toggleView.BeforeLoadDFMValues;
  btnETQ.BeforeLoadDFMValues;
  btnLoadFILE.BeforeLoadDFMValues;
  WebMessageDlg1.BeforeLoadDFMValues;
  nArq.BeforeLoadDFMValues;
  nRESP.BeforeLoadDFMValues;
  myBtn.BeforeLoadDFMValues;
  WebBitBtn1.BeforeLoadDFMValues;
  Produtos_Con.BeforeLoadDFMValues;
  Produtos_DSET.BeforeLoadDFMValues;
  Cargas_idudv.BeforeLoadDFMValues;
  Cargas_DataMvto.BeforeLoadDFMValues;
  Cargas_QtdeUD.BeforeLoadDFMValues;
  execAPIs.BeforeLoadDFMValues;
  try
    Name := 'Transform';
    Width := 1000;
    Height := 848;
    Caption := 'Produtos_Con';
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -13;
    Font.Name := 'Tahoma';
    Font.Style := [];
    FormContainer := 'appcontent';
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    divTabela.SetParentComponent(Self);
    divTabela.Name := 'divTabela';
    divTabela.Left := 284;
    divTabela.Top := 49;
    divTabela.Width := 96;
    divTabela.Height := 25;
    divTabela.ChildOrder := 2;
    divTabela.Role := '';
    btnPesquisar.SetParentComponent(Self);
    btnPesquisar.Name := 'btnPesquisar';
    btnPesquisar.Left := 164;
    btnPesquisar.Top := 49;
    btnPesquisar.Width := 96;
    btnPesquisar.Height := 25;
    btnPesquisar.Caption := 'Leituras';
    btnPesquisar.ChildOrder := 1;
    btnPesquisar.HeightPercent := 100.000000000000000000;
    btnPesquisar.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisar, Self, 'OnClick', 'btnPesquisarClick');
    btnImprimir.SetParentComponent(Self);
    btnImprimir.Name := 'btnImprimir';
    btnImprimir.Left := 164;
    btnImprimir.Top := 80;
    btnImprimir.Width := 96;
    btnImprimir.Height := 25;
    btnImprimir.Caption := 'Imprimir';
    btnImprimir.ChildOrder := 2;
    btnImprimir.HeightPercent := 100.000000000000000000;
    btnImprimir.WidthPercent := 100.000000000000000000;
    SetEvent(btnImprimir, Self, 'OnClick', 'btnImprimirClick');
    Msg01.SetParentComponent(Self);
    Msg01.Name := 'Msg01';
    Msg01.Left := 128;
    Msg01.Top := 8;
    Msg01.Width := 24;
    Msg01.Height := 24;
    Msg01.Buttons := [];
    Msg01.Opacity := 0.200000000000000000;
    toggleView.SetParentComponent(Self);
    toggleView.Name := 'toggleView';
    toggleView.Left := 400;
    toggleView.Top := 49;
    toggleView.Width := 96;
    toggleView.Height := 25;
    toggleView.Caption := 'toggleView';
    toggleView.ChildOrder := 4;
    toggleView.ElementFont := efCSS;
    toggleView.ElementPosition := epIgnore;
    toggleView.HeightStyle := ssAuto;
    toggleView.HeightPercent := 100.000000000000000000;
    toggleView.WidthStyle := ssAuto;
    toggleView.WidthPercent := 100.000000000000000000;
    btnETQ.SetParentComponent(Self);
    btnETQ.Name := 'btnETQ';
    btnETQ.Left := 164;
    btnETQ.Top := 111;
    btnETQ.Width := 96;
    btnETQ.Height := 25;
    btnETQ.Caption := 'Processar';
    btnETQ.ChildOrder := 5;
    btnETQ.HeightPercent := 100.000000000000000000;
    btnETQ.WidthPercent := 100.000000000000000000;
    SetEvent(btnETQ, Self, 'OnClick', 'btnETQClick');
    btnLoadFILE.SetParentComponent(Self);
    btnLoadFILE.Name := 'btnLoadFILE';
    btnLoadFILE.Left := 284;
    btnLoadFILE.Top := 80;
    btnLoadFILE.Width := 96;
    btnLoadFILE.Height := 25;
    btnLoadFILE.ChildOrder := 6;
    SetEvent(btnLoadFILE, Self, 'OnChange', 'btnLoadFILEChange');
    SetEvent(btnLoadFILE, Self, 'OnGetFileAsText', 'btnLoadFILEGetFileAsText');
    WebMessageDlg1.SetParentComponent(Self);
    WebMessageDlg1.Name := 'WebMessageDlg1';
    WebMessageDlg1.Left := 896;
    WebMessageDlg1.Top := 4;
    WebMessageDlg1.Width := 24;
    WebMessageDlg1.Height := 24;
    WebMessageDlg1.Buttons := [];
    WebMessageDlg1.Opacity := 0.200000000000000000;
    nArq.SetParentComponent(Self);
    nArq.Name := 'nArq';
    nArq.Left := 24;
    nArq.Top := 304;
    nArq.Width := 729;
    nArq.Height := 89;
    nArq.ElementFont := efCSS;
    nArq.ElementPosition := epIgnore;
    nArq.HeightStyle := ssAuto;
    nArq.HeightPercent := 100.000000000000000000;
    nArq.ReadOnly := True;
    nArq.SelLength := 0;
    nArq.SelStart := 0;
    nArq.WidthStyle := ssAuto;
    nArq.WidthPercent := 100.000000000000000000;
    SetEvent(nArq, Self, 'OnDblClick', 'nArqDblClick');
    nRESP.SetParentComponent(Self);
    nRESP.Name := 'nRESP';
    nRESP.Left := 24;
    nRESP.Top := 415;
    nRESP.Width := 729;
    nRESP.Height := 98;
    nRESP.ElementClassName := 'form-control';
    nRESP.ElementFont := efCSS;
    nRESP.Font.Charset := ANSI_CHARSET;
    nRESP.Font.Color := clWindowText;
    nRESP.Font.Height := -8;
    nRESP.Font.Name := 'Open Sans';
    nRESP.Font.Style := [];
    nRESP.HeightStyle := ssPercent;
    nRESP.HeightPercent := 92.000000000000000000;
    nRESP.ParentFont := False;
    nRESP.ReadOnly := True;
    nRESP.SelLength := 0;
    nRESP.SelStart := 0;
    nRESP.Visible := False;
    nRESP.WidthPercent := 98.000000000000000000;
    myBtn.SetParentComponent(Self);
    myBtn.Name := 'myBtn';
    myBtn.Left := 284;
    myBtn.Top := 111;
    myBtn.Width := 96;
    myBtn.Height := 25;
    myBtn.Caption := 'Modal';
    myBtn.ChildOrder := 10;
    myBtn.ElementFont := efCSS;
    myBtn.ElementPosition := epIgnore;
    myBtn.HeightStyle := ssAuto;
    myBtn.HeightPercent := 100.000000000000000000;
    myBtn.WidthStyle := ssAuto;
    myBtn.WidthPercent := 100.000000000000000000;
    SetEvent(myBtn, Self, 'OnClick', 'myBtnClick');
    WebBitBtn1.SetParentComponent(Self);
    WebBitBtn1.Name := 'WebBitBtn1';
    WebBitBtn1.Left := 400;
    WebBitBtn1.Top := 8;
    WebBitBtn1.Width := 80;
    WebBitBtn1.Height := 25;
    WebBitBtn1.Caption := 'WebBitBtn1';
    WebBitBtn1.Color := clNone;
    WebBitBtn1.HeightPercent := 100.000000000000000000;
    WebBitBtn1.WidthPercent := 100.000000000000000000;
    SetEvent(WebBitBtn1, Self, 'OnClick', 'WebBitBtn1Click');
    Produtos_Con.SetParentComponent(Self);
    Produtos_Con.Name := 'Produtos_Con';
    Produtos_Con.Active := False;
    Produtos_Con.DataNode := 'data';
    Produtos_Con.Delimiter := ';';
    Produtos_Con.URI := 'http://localhost:8082/api/carga?offset=0&fetch=10&iduser=47&qtdesaldo%3E0';
    Produtos_Con.AfterConnect := Produtos_ConAfterConnect;
    Produtos_Con.Left := 56;
    Produtos_Con.Top := 8;
    Produtos_DSET.SetParentComponent(Self);
    Produtos_DSET.Name := 'Produtos_DSET';
    Produtos_DSET.Connection := Produtos_Con;
    Produtos_DSET.Left := 56;
    Produtos_DSET.Top := 64;
    Cargas_idudv.SetParentComponent(Produtos_DSET);
    Cargas_idudv.Name := 'Cargas_idudv';
    Cargas_idudv.FieldName := 'idudv';
    Cargas_DataMvto.SetParentComponent(Produtos_DSET);
    Cargas_DataMvto.Name := 'Cargas_DataMvto';
    Cargas_DataMvto.FieldName := 'datamvto';
    Cargas_QtdeUD.SetParentComponent(Produtos_DSET);
    Cargas_QtdeUD.Name := 'Cargas_QtdeUD';
    Cargas_QtdeUD.FieldName := 'qtdeud';
    execAPIs.SetParentComponent(Self);
    execAPIs.Name := 'execAPIs';
    execAPIs.Left := 131;
    execAPIs.Top := 177;
  finally
    divTabela.AfterLoadDFMValues;
    btnPesquisar.AfterLoadDFMValues;
    btnImprimir.AfterLoadDFMValues;
    Msg01.AfterLoadDFMValues;
    toggleView.AfterLoadDFMValues;
    btnETQ.AfterLoadDFMValues;
    btnLoadFILE.AfterLoadDFMValues;
    WebMessageDlg1.AfterLoadDFMValues;
    nArq.AfterLoadDFMValues;
    nRESP.AfterLoadDFMValues;
    myBtn.AfterLoadDFMValues;
    WebBitBtn1.AfterLoadDFMValues;
    Produtos_Con.AfterLoadDFMValues;
    Produtos_DSET.AfterLoadDFMValues;
    Cargas_idudv.AfterLoadDFMValues;
    Cargas_DataMvto.AfterLoadDFMValues;
    Cargas_QtdeUD.AfterLoadDFMValues;
    execAPIs.AfterLoadDFMValues;
  end;
end;

end.
